import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRemoveFromBasket2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconRemoveFromBasket2"><Path d="M8 3.5L6.09917 8.25207M16 3.5L17.9008 8.25207M11.5 20.5H4.5L2.5 8.5H21.5L20.8333 12.5M15.3787 20.6213L17.5 18.5M17.5 18.5L19.6213 16.3787M17.5 18.5L15.3787 16.3787M17.5 18.5L19.6213 20.6213" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconRemoveFromBasket2;
